export default __webpack_public_path__ + "static/media/sumo-interface.5233fab8.md";